import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NewsLettersAction } from "../../Redux/Actions/OrganizationAction";
import Breadcrumb from "../DefaultComponent/BreadCrumb";
import { formatDate, calculateTotalPages } from "../../utils/Helper";
import { Pagination, Stack, Tooltip } from "@mui/material";

const NewsLetters = () => {
  const dispatch = useDispatch<any>();
  const [count, setcount]: any = useState(0);
  const [loading, setLoading]: any = useState(false);
  const [NewsLetterList, setNewsLetterList] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(12);
  const NewsLettertListData = useSelector(
    (state: any) => state.NewsLettertListData
  );

  useEffect(() => {
    const params = `?page=${page}&page_size=${rowsPerPage}`;
    dispatch(NewsLettersAction(params));
  }, [dispatch, page, rowsPerPage]);

  useEffect(() => {
    if (NewsLettertListData.data?.row) {
      setNewsLetterList(() => NewsLettertListData?.data?.row);
      setcount(() => NewsLettertListData?.data?.total_count);
    }
  }, [NewsLettertListData]);

  return (
    <>
      <div className="page-wrapper card" style={{ display: "block" }}>
        <Breadcrumb
          pageTitle="Organizations"
          breadcrumbs={[
            {
              label: "HelpnSupport",
              path: "/support_requests/newsletter",
              isActive: false,
            },
            {
              label: "Queries",
              path: "/support_requests/newsletter",
              isActive: true,
            },
          ]}
        />

        <div className="container-fluid mt-5">
          <div className="card">
            <div className="table-responsive">
              <table className="table">
                <thead className="table-dark">
                  <tr>
                    <th scope="col">S.No</th>
                    <th scope="col">Email</th>
                    <th scope="col">CreatedAt</th>
                    <th scope="col">ModifiedAt</th>
                  </tr>
                </thead>
                <tbody>
                  {NewsLetterList?.length > 0
                    ? NewsLetterList?.map(
                        (newsletterList: any, newsletterListkey: any) => {
                          return (
                            <Fragment key={newsletterListkey}>
                              <tr>
                                <th scope="row">
                                  {(page - 1) * rowsPerPage +
                                    (newsletterListkey + 1)}
                                </th>
                                <td>{newsletterList?.email}</td>
                                <td>
                                  {formatDate(newsletterList?.created_at)}
                                </td>
                                <td>
                                  {formatDate(newsletterList?.modified_at)}
                                </td>
                              </tr>
                            </Fragment>
                          );
                        }
                      )
                    : ""}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pagination-style">
            <Stack spacing={2}>
              <Pagination
                count={calculateTotalPages(count, rowsPerPage)}
                color="primary"
                variant="outlined"
                shape="rounded"
                page={page}
                onChange={(e: any, newPage) => setPage(newPage)}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsLetters;
